import HomeScreen from "./Screens/HomeScreen";
import TermsScreen from "./Screens/TermsScreen";
import PrivacyScreen from "./Screens/PrivacyScreen";
import OldPrivacyScreen from "./Screens/OldPrivacyScreen";
import ScrollToTop from "./ScrollToTop";
import { BrowserRouter, Routes, Route } from "react-router";
import { useEffect } from "react";
import AnalyticsListener from "./AnalyticsListener";

function App() {
  useEffect(() => {
    // Increment the page count on page load
    async function updatePageViewCount() {
      try {
        await fetch(
          "https://s8kgicsb5f.execute-api.us-west-1.amazonaws.com/default/add",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } catch (error) {}
    }
    updatePageViewCount();
  }, []);

  return (
    <BrowserRouter>
      <AnalyticsListener />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/terms" element={<TermsScreen />} />
        <Route path="/privacy" element={<PrivacyScreen />} />
        <Route path="/oldPrivacy" element={<OldPrivacyScreen />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
